import React, { Component } from "react";
import "../../css/customertransactions.css";
import {getTimeInIST, format_date_only, format_display_DDMMYYYY, format_fancy} from '../../Utils';
import {Table, Button} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from 'react-bootstrap-typeahead';
import { UserService } from "../../Services/UserService";
import { ReportService } from "../../Services/ReportService";
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import { RowCountOptions } from "../../Config";

const styles = theme =>({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    }
  });

class CustomerTransactions extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        current_rows: [],
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        message : "",
        userList: [],
        selectedCustomer: {},
        numItemsPerPage: RowCountOptions[0],
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        columns : [
            { id: 'route_id', numeric: false, disablePadding: false, label: 'Route', sortable: false },
            { id: 'schedule_date', numeric: false, disablePadding: false, label: 'Schedule Date' , sortable: false },
            { id: 'product_name', numeric: false, disablePadding: false, label: 'Product', sortable: false  },
            { id: 'product_qty', numeric: true, disablePadding: false, label: 'Qty', sortable: false  },
            { id: 'total_amount', numeric: true, disablePadding: false, label: 'Total Amount', sortable: false  },
            { id: 'delivered_count', numeric: true, disablePadding: false, label: 'Delivered Count', sortable: false  },
            { id: 'bottles_returned', numeric: true, disablePadding: false, label: 'Bottles Returned Count' , sortable: false },
            { id: 'delivery_date',  align:"center", numeric: false, disablePadding: false, label: 'Delivery Date', sortable: false  }
        ],
      }

      this.handleSelect = this.handleSelect.bind(this);
      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
    }
    
    componentWillMount(){
        this.props.isLoading(true);
        UserService.getCustomerNames()
        .then((data) => {
            this.setState({userList: data.users});
            
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    sortBy = (event, property) => {
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchTransactions(0, this.state.numItemsPerPage));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(e){
        e.preventDefault();
        this.props.isLoading(true);
        ReportService.getReportCustomerTotalTransactions(this.state.selectedCustomer.id, this.state.startDate, this.state.endDate)
        .then((data) => {
            console.log(data);
            this.setState({
                totalItems: data.count, 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1,
                currentPageNumber: 0
            });
            if(data.count === 0) {
                this.setState({message: "No Transactions available."});
            }
            this.fetchTransactions(0, this.state.numItemsPerPage);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchTransactions(start, numberItems){
        ReportService.getReportCustomerTransactions(this.state.selectedCustomer.id, this.state.startDate, this.state.endDate, start, numberItems)
        .then((data) => {
            let rows = [];
            console.log(data);
            this.setState({data: data.transactions});
            data.transactions.forEach((transaction) => {
                rows.push(<TransactionDetails key={transaction.id} transaction={transaction}/>);
            });
            this.setState({
                current_rows: rows
            });
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage){
        this.fetchTransactions(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    handleChangeStart(date){
        this.setState({
            startDate: date
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date
        });
    }
    
    render() {
        const message = this.state.message;
        return (
            <div className="Home customer_transactions">
                <h3 style={{marginBottom: '20px'}}>Customer Transactions</h3>
                <div className="rangeContainer">
                <div className="centerwrapper">
                    <div className="longer_square">
                        <Typeahead
                            id="typeahead-id-customer-transactions"
                            onChange={(selected) => {
                                this.setState({ selectedCustomer: selected[0] });
                            }}
                            options={this.state.userList}
                            labelKey="name"
                            placeholder="Choose a Customer"
                            clearButton
                        />
                    </div>
                    <div className = "squareLabel marginRight marginLeft">From</div>
                    <div className = "square">
                        <DatePicker 
                            className="datePicker"
                            selected={this.state.startDate}
                            selectsStart
                            dateFormat={format_date_only}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleChangeStart} />
                    </div>
                    <div className = "squareLabel">To</div>
                    <div className = "square">
                        <DatePicker
                            className="datePicker"
                            selected={this.state.endDate}
                            selectsEnd
                            dateFormat={format_date_only}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleChangeEnd}
                        />
                    </div>
                    <div className = "square">
                        <Button onClick={(e) => { this.fetchData(e)}}>REFRESH</Button>
                    </div>
                </div>
                </div>
                {/* { this.state.totalPages > 0 && 
                    <Pager>
                        <Pager.Item previous disabled={this.state.currentPageNumber  === 0}  eventKey="prev" onSelect={this.handleSelect} href="#">
                            &larr; Previous Page {this.state.currentPageNumber  === 0 ? "" : this.state.currentPageNumber }
                        </Pager.Item>
                        <Pager.Item next disabled={this.state.currentPageNumber  === this.state.totalPages} eventKey="next" onSelect={this.handleSelect} href="#" >
                            Next Page {this.state.currentPageNumber  === this.state.totalPages ? "": this.state.currentPageNumber + 2} &rarr;
                        </Pager.Item>
                    </Pager>
                } */}
                { this.state.current_rows.length > 0 && !this.props.loading &&
                    <div className="container">
                        <Paper className={this.props.classes.root} style={{width: "100%", paddingTop : '15px',marginTop: "5px", paddingLeft: "5px", paddingRight: "5px"}}>
                            <Table striped condensed hover responsive>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows ={this.state.columns} />
                                <TableBody>
                                {this.state.current_rows}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                        </Paper>
                    </div>
                }
                {
                    message && 
                    (
                        <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    )
                }
            </div>
        );
    }

}

class TransactionDetails extends Component {

    render(){
      const transaction = this.props.transaction;
      return (
        <tr>
            <td>{transaction.route_id}</td>
            <td>{moment(transaction.schedule_date).format(format_display_DDMMYYYY)}</td>
            <td>{transaction.product_name}</td>
            <td align="right">{transaction.product_qty}</td>
            <td align="right">{transaction.total_amount}</td>
            <td align="right">{transaction.delivered_count}</td>
            <td align="right">{transaction.bottles_returned}</td>
            <td align="center">{transaction.delivery_date? getTimeInIST(transaction.delivery_date).format(format_fancy) : ""}</td>
        </tr>
      );
    }
}

export default withStyles(styles)(CustomerTransactions);